import styled from "styled-components";

export default styled.div`
  .layout {
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: ${(props) => props.theme.colors.white};
  }

  .floor {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 5px;
    gap: 5px;
    border: 1px solid ${(props) => props.theme.colors.primary};
  }

  .apartment {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    font-size: 1em;
  }

  .exist {
    background-color: ${(props) => props.theme.colors.green1};
  }
  .notExist {
    background-color: ${(props) => props.theme.colors.white};
    cursor: auto;
    box-shadow: none;
  }
`;
